export enum CountryActionTypes {
  CHANGE_COUNTRY = "CHANGE_COUNTRY",
  UPDATE_COUNTRY = "UPDATE_COUNTRY",
}
